"use strict";
var TypeaheadConfig = (function () {
    function TypeaheadConfig() {
    }
    return TypeaheadConfig;
}());
exports.TypeaheadConfig = TypeaheadConfig;
//# sourceMappingURL=D:/a/1/s/typeahead/src/models/typeahead.config.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/models/typeahead.config.js